import React from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import gtmHandler from "AtomicUtils/gtmHandler"
import { Caption, A, H5, Interactive, Tag, P, Space, Button } from "AtomicComponents"
import styles from "./MyMazdaDashboard.less"
import buttonStyles from "AtomicComponents/Button/Button.less"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

class MyMazdaDashboardItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mounted: false
    }
  }

  componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  render() {
    const { wide = false, heading, description, progress, imageSrc, scheduledServiceImage, nextServiceDate, policyItems, isExternal = false, buttonUrl, buttonLinkText } = this.props
    const { mounted } = this.state
    const progressValue = (progress / 100) >= 1 ? 0 : 691.15 * (1 - (progress / 100))

    return (
      <div className={classnames({
        [styles.MyMazdaDashboardItem]: true,
        [styles.MyMazdaDashboardItemWide]: wide
      })}>
        {
          wide && imageSrc &&
          <div className={classnames({
            [styles.MyMazdaDashboardItemWideImage]: true
          })}>
            <img src={imageSrc} />
          </div>
        }
        <div className={classnames({
          [styles.MyMazdaDashboardItemHeading]: true
        })}>
          <H5 withDetails>{heading}</H5>
          {
            wide ?
            <div>
              <div className={classnames({
                [styles.MyMazdaDashboardItemImage]: true
              })}>
                <img src={imageSrc + "?width=104"} />
              </div>
              <P withoutMargin>{description}</P>
            </div> :
            <Interactive>{description}</Interactive>
          }
          {progress > 100 ? <P withoutMargin><Tag color="red">OVERDUE</Tag></P> : (!wide && <Space/>)}
          {!wide && <Space />}
        </div>
        {
          !wide && imageSrc &&
          <div className={classnames({
            [styles.MyMazdaDashboardItemImage]: true
          })}>
            <img src={imageSrc + "?width=626"} />
          </div>
        }
        {
          nextServiceDate &&
          <div className={classnames({
            [styles.MyMazdaDashboardItemService]: true
          })}>
            <svg viewBox="0 0 224 224">
              <circle
                cx="112"
                cy="112"
                r="110"
                fill="none"
                stroke="#E7E7E7"
                strokeWidth="4" />
              <circle
                cx="112"
                cy="112"
                r="110"
                fill="none"
                stroke="#910A2D"
                strokeWidth="4"
                strokeDasharray="691.15"
                strokeDashoffset={mounted ? progressValue : "691.15"}
                style={{
                  transitionDuration: ".8s",
                  transitionDelay: "1s",
                  transitionTimingFunction: "cubic-bezier(0, 0.6, 1, 1)",
                  willChange: "stroke-dashoffset"
                }} />
            </svg>
            <div className={classnames({
              [styles.MyMazdaDashboardItemServiceContent]: true
            })}>
              <img src={scheduledServiceImage} alt="Next service" />
              <Space/>
              <Interactive>Due before</Interactive>
              <P withoutMargin>{nextServiceDate}</P>
            </div>
          </div>
        }
        {
          policyItems &&
          <div className={classnames({
            [styles.MyMazdaDashboardItemPolicy]: true
          })}>
            {policyItems.map((policy, index) => {
              return (
                <div
                  key={index}
                >
                  <Space />
                  <div
                    className={classnames({
                      [styles.MyMazdaDashboardItemPolicyItem]: true
                    })}
                  >
                    <Caption grey>{policy.heading.toUpperCase()}</Caption>
                    {policy.buttonType === "external" ? (
                      <A external withoutStyle href={policy.buttonUrl}>
                        <Caption grey>{policy.buttonLinkText}</Caption>
                      </A>
                    ) : (
                      <Link
                        to={policy.buttonUrl}
                        className={classnames({
                          [typographyStyles.withoutStyle]: (!policy.isExpired || policy.policyType === "Warranty")
                        })}
                      >
                        <Caption
                            grey={!policy.isExpired || policy.policyType === "Warranty"}
                          black={policy.buttonType === "date"}
                        >
                          {policy.buttonLinkText}
                        </Caption>
                      </Link>
                    )}
                  </div>
                  <div className={classnames({
                    [styles.MyMazdaDashboardItemPolicyProgress]: true
                  })}>
                    <div style={{ width: policy.policyType !== "Warranty" ? `${policy.progress}%` : "0%" }} />
                  </div>
                  <Space />
                  <Space />
                </div>
              )
            })}
          </div>
        }
        {!wide && <Space />}
        {
          isExternal ?
          <Button
            styleName="blackOutlined"
            href={buttonUrl}
            label={buttonLinkText}
            gtm={{
              category: "MyMazda - Dashboard",
              action: `${heading.toUpperCase()} - clicked "${buttonLinkText.toUpperCase()}"`
            }}
          />
          :
          <Link
            to={buttonUrl}
            className={classnames({
              [typographyStyles.withoutStyle]: true
            })}>
            <span
              className={`Button ${classnames({
                [buttonStyles.Button]: true,
                [buttonStyles.ButtonFullWidth]: true,
                [buttonStyles.ButtonBlackOutlined]: true
              })}`}
              onClick={() => {
                gtmHandler({
                  pageCategory: "MyMazda - Dashboard",
                  pageAction: `${heading.toUpperCase()} - clicked "${buttonLinkText.toUpperCase()}"`
                })
              }}
            >{buttonLinkText}</span>
          </Link>
        }
      </div>
    )
  }
}

export default MyMazdaDashboardItem



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaDashboard/MyMazdaDashboardItem.jsx